const DateIcon = () => (
	<svg viewBox="0 0 24 24" fill="currentColor" stroke="none">
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M7 3C7 2.44772 7.44772 2 8 2C8.55228 2 9 2.44772 9 3V4H15V3C15 2.44772 15.4477 2 16 2C16.5523 2 17 2.44772 17 3V4H19C20.1046 4 21 4.89543 21 6V20C21 21.1046 20.1046 22 19 22H5C3.89543 22 3 21.1046 3 20V6C3 4.89543 3.89543 4 5 4H7V3ZM19.5 9V6C19.5 5.72386 19.2761 5.5 19 5.5H5C4.72386 5.5 4.5 5.72386 4.5 6V9H19.5ZM4.5 10.5V20C4.5 20.2761 4.72386 20.5 5 20.5H19C19.2761 20.5 19.5 20.2761 19.5 20V10.5H4.5Z"
		/>
		{/* Calendar grid dots */}
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M8 13.5C8.55228 13.5 9 13.9477 9 14.5C9 15.0523 8.55228 15.5 8 15.5C7.44772 15.5 7 15.0523 7 14.5C7 13.9477 7.44772 13.5 8 13.5ZM12 13.5C12.5523 13.5 13 13.9477 13 14.5C13 15.0523 12.5523 15.5 12 15.5C11.4477 15.5 11 15.0523 11 14.5C11 13.9477 11.4477 13.5 12 13.5ZM17 14.5C17 13.9477 16.5523 13.5 16 13.5C15.4477 13.5 15 13.9477 15 14.5C15 15.0523 15.4477 15.5 16 15.5C16.5523 15.5 17 15.0523 17 14.5ZM8 17.5C8.55228 17.5 9 17.9477 9 18.5C9 19.0523 8.55228 19.5 8 19.5C7.44772 19.5 7 19.0523 7 18.5C7 17.9477 7.44772 17.5 8 17.5Z"
		/>
	</svg>
);
export default DateIcon;